import { defineFetch } from 'resift';

const makeGetClientOrgChart = defineFetch({
  displayName: 'Get Client Org Chart',
  make: () => ({
    request: () => ({ http }) =>
      http({
        method: 'GET',
        route: '/client/org-chart',
      }),
  }),
});

const getClientOrgChart = makeGetClientOrgChart();

export default getClientOrgChart;
